import { Save } from "lucide-react";
import React, { useEffect, useState } from "react";

const BASE = "https://webhook.harmonyalgo.com/api";

const Row = ({ item, inputs, handlechange, formatDate }) => {
  return (
    <tr
      key={item.id}
      className="hover:bg-zinc-800/50 transition-colors"
    >
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        {item.label}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        <input
          name={item.key}
          onChange={handlechange}
          value={inputs[item.key]}
          className="w-full focus:outline-none text-md text-white-400 bg-transparent"
        />
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-400">
        {formatDate(item.updated_at)}
      </td>
    </tr>
  );
};

const Config = ({ formatDate }) => {
  // const [tableData, setTableData] = useState([{ id: 1, key: 'webhook_url', label: 'Webhook URL', value: 'https://zapier.com' }]);
  const [tableData, setTableData] = useState([]);
  const [inputs, setInputs] = useState({})
  const [token, setToken] = useState("")
  const [newInputs, setNewInputs] = useState({})

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(`${BASE}/config`);
      const resJson = await res.json();
      // const resJson = [{ id: 1, key: 'webhook_url', label: 'Webhook URL', value: 'https://zapier.com' }]
      setTableData(resJson);
      resJson.map((row) => setInputs((inputs) => ({ ...inputs, [row.key]: row.value })))
    };
    fetchData();
    const match = document.cookie.match(new RegExp('(^| )token=([^;]+)'));
    if (match) {
      setToken(match[2])
    }
  }, []);

  const handlechange = (event) => {
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }))
    setNewInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }))
  }

  const handleSubmit = async () => {
    const res = await fetch(`${BASE}/update_config`, {
      method: "POST",
      body: JSON.stringify(newInputs),
      headers: { "Content-Type": "application/json" },
    });
    const resJson = await res.json();
    console.log(resJson)
    setNewInputs({})
  }

  return (
    <>
      <div>
        <div className="flex justify-between">
          <div className="mb-4">
            {Object.keys(newInputs).length === 0 ? (
              <span className="text-zinc-600">No unsaved settings.</span>
            ) : (
              <button onClick={handleSubmit} className="mr-4 p-1 bg-teal-100/80 text-zinc-600 text-sm rounded hover:bg-teal-200 focus:outline-none focus:ring-2 focus:ring-zinc-500"><Save /></button>
            )}
          </div>
          <div className="flex items-center text-zinc-600">
            <label>Key:</label>
            <input
              name="token"
              onChange={(e) => {
                setToken(e.target.value)
              }}
              onKeyDown={(e) => {
                if (e.code === 'Enter') {
                  document.cookie = `token=${token}; max-age=8640000`
                }
              }}
              value={token}
              className="w-full ml-2 focus:outline-none text-md text-white-400 bg-transparent"
            />
          </div>
        </div>

        <div className="rounded-lg border border-zinc-800 bg-zinc-900">
          <div className="overflow-x-auto">
            <table className="w-full">
              <tbody className="divide-y divide-zinc-800">
                {tableData.map((item) => (
                  <Row
                    key={item.key}
                    item={item}
                    inputs={inputs}
                    handlechange={handlechange}
                    formatDate={formatDate}
                  />
                ))}
                {tableData.length ? null : (
                  <tr className="m-4 px-1 py-4 whitespace-nowrap text-sm text-zinc-100">
                    No items.
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export { Config }
